import ReactDOM from "react-dom";
import { MoreHorizontal, Share, SquarePlus, MoreVertical, X } from "lucide-react";

const STEPS = {
    ios: [
        { icon: MoreHorizontal, text: 'Toque em "•••" na barra do Safari (se o ícone de compartilhar não aparecer direto).' },
        { icon: Share, text: "Toque no ícone de compartilhar." },
        { icon: SquarePlus, text: 'Selecione "Adicionar à Tela de Início".' },
        { icon: SquarePlus, text: 'Toque em "Adicionar" para confirmar.' },
    ],
    android: [
        { icon: MoreVertical, text: "Toque no menu (⋮) no canto superior do Chrome." },
        { icon: SquarePlus, text: 'Selecione "Instalar app" ou "Adicionar à tela inicial".' },
        { icon: SquarePlus, text: "Confirme para adicionar o atalho." },
    ],
};

const InstallAppInstructionsDialog = ({ open, onClose, platform }) => {
    if (!open) return null;

    const steps = STEPS[platform] ?? [];

    return ReactDOM.createPortal(
        <div className="fixed inset-0 bg-gray-800 bg-opacity-70 flex justify-center items-center z-[9999]">
            <div className="bg-white p-6 rounded-lg shadow-lg max-w-sm w-full mx-4 sm:mx-8 relative">
                <button
                    type="button"
                    onClick={onClose}
                    aria-label="Fechar"
                    className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
                >
                    <X className="h-5 w-5" />
                </button>

                <p className="text-lg font-semibold text-gray-800 mb-4">Como instalar o app</p>

                <div className="flex flex-col gap-4">
                    {steps.map((step, index) => {
                        const Icon = step.icon;
                        return (
                            <div key={index} className="flex items-start gap-3 text-left">
                                <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-purple-100 text-purple-600">
                                    <Icon className="h-4 w-4" />
                                </div>
                                <p className="text-sm text-gray-700 pt-1.5">{step.text}</p>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>,
        document.body
    );
};

export default InstallAppInstructionsDialog;
